import { assertNever } from 'src_common/common/assertNever';
import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

const getAction = (action: 'approve' | 'reject'): string => {
    switch (action) {
        case 'approve':
            return 'approve';
        case 'reject':
            return 'reject';
        default:
            return assertNever('action', action);
    }
};

const decode = (status: number, data: ResponseType): unknown => {
    if (status === 200 || status === 201) {
        return;
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface PostPutParamsWithdrawalRuleType {
    id?: number | null;
    card: string;
    accountId: number;
    ruleType: 'reject' | 'approve';
    amount: number | null;
    reason: Array<string> | null;
    note: string | null;
}

export const postPutWithdrawalRule = {
    browser: {
        params: (params: PostPutParamsWithdrawalRuleType): ParamsFetchType<PostPutParamsWithdrawalRuleType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/automatic-withdrawal-rule/create-or-edit',
                body: params,
            };
        },
        decode: decode,
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/automatic-withdrawal-rule/create-or-edit',
    },
    generateUrlApi: async (
        params: GenerateUrlApiParamsType<PostPutParamsWithdrawalRuleType>
    ): Promise<GenerateUrlApiType> => {
        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                },
            };
        }

        const { id, card, accountId, ruleType, amount, reason, note } = params.req.body;

        const finalUrl = `${params.API_URL}/automatic-withdrawal-rule/${params.API_UNIVERSE}`;

        return {
            url: finalUrl,
            passToBackend: true,
            method: MethodType.POST,
            body: {
                id: id,
                card: card,
                accountId: accountId,
                ruleType: getAction(ruleType),
                amount: amount,
                reason: reason,
                note: note,
            },
        };
    },
};
